import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d8af27a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "in-delivery-payment" }
const _hoisted_2 = { class: "in-delivery-payment__payment payment" }
const _hoisted_3 = { class: "payment__title" }
const _hoisted_4 = { class: "payment__to-paid rouble-symbol" }
const _hoisted_5 = { class: "payment__types" }
const _hoisted_6 = { class: "in-delivery-payment__description description" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "description__title" }, " Состав заказа: ", -1))
const _hoisted_8 = { class: "description__item-list" }
const _hoisted_9 = { class: "product__image" }
const _hoisted_10 = ["src", "alt"]
const _hoisted_11 = { class: "product__info product-info" }
const _hoisted_12 = { class: "product-info__name" }
const _hoisted_13 = { class: "product-info__count rouble-symbol" }
const _hoisted_14 = { class: "description__prices" }
const _hoisted_15 = { class: "item" }
const _hoisted_16 = { class: "item__title" }
const _hoisted_17 = { class: "item__value rouble-symbol" }
const _hoisted_18 = {
  key: 0,
  class: "item"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item__title" }, " скидка по акции ", -1))
const _hoisted_20 = { class: "item__value rouble-symbol" }
const _hoisted_21 = {
  key: 1,
  class: "item"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item__title" }, " оплачено бонусами ", -1))
const _hoisted_23 = { class: "item__value" }
const _hoisted_24 = { class: "item__title" }
const _hoisted_25 = { class: "item__value rouble-symbol" }
const _hoisted_26 = {
  key: 3,
  class: "item"
}
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item__title" }, " Доставка ", -1))
const _hoisted_28 = { class: "item__value rouble-symbol" }
const _hoisted_29 = {
  key: 4,
  class: "item summary-price"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item__title" }, " Итого: ", -1))
const _hoisted_31 = { class: "item__value rouble-symbol" }
const _hoisted_32 = {
  key: 1,
  class: "in-delivery-payment__loader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypePanel = _resolveComponent("TypePanel")!
  const _component_MoSpinner = _resolveComponent("MoSpinner")!
  const _component_SBPPanel = _resolveComponent("SBPPanel")!
  const _component_ModalDialog = _resolveComponent("ModalDialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.order)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, " Оплата заказа №" + _toDisplayString(_ctx.order.id), 1),
            _createElementVNode("div", _hoisted_4, " Сумма к оплате: " + _toDisplayString(_ctx.order.totalPrice), 1),
            _createElementVNode("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.paymentTypes, (type) => {
                return (_openBlock(), _createBlock(_component_TypePanel, {
                  key: type.paymentTypeId,
                  type: type,
                  "type-id": type.paymentTypeId,
                  "is-active": type.paymentTypeId === _ctx.paymentTypeStore.type,
                  onSelect: _ctx.selectPaymentType
                }, null, 8, ["type", "type-id", "is-active", "onSelect"]))
              }), 128))
            ]),
            _createElementVNode("button", {
              class: _normalizeClass(["payment__process-btn base-btn base-btn--black", {
            'base-btn--disabled': !_ctx.paymentTypeStore.type || _ctx.paymentTypes.every(({ isEnabled }) => !isEnabled),
          }]),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.process && _ctx.process(...args)))
            }, " Оплатить заказ ", 2)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order.items, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item,
                  class: "description__product product"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("img", {
                      src: item.product.image,
                      alt: item.name
                    }, null, 8, _hoisted_10)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, _toDisplayString(item.name), 1),
                    _createElementVNode("div", _hoisted_13, _toDisplayString(item.quantity) + " X " + _toDisplayString(item.price), 1)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.allItemsCount) + " " + _toDisplayString(_ctx.pluralize(_ctx.allItemsCount, ['блюдо', 'блюда', 'блюд'])) + " в корзине ", 1),
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.order.totalPriceWithoutDiscount)), 1)
              ]),
              (_ctx.order.totalDiscount > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    _hoisted_19,
                    _createElementVNode("div", _hoisted_20, " -" + _toDisplayString(_ctx.$filters.formattedNumber(_ctx.order.totalDiscount)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.order.bonusesWriteOffSum > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("div", _hoisted_23, " -" + _toDisplayString(_ctx.$filters.formattedNumber(_ctx.order.bonusesWriteOffSum)) + " БП ", 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.delivery.restaurants.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.delivery.restaurants, (restaurant) => {
                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                      (restaurant.price > 0)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: restaurant,
                            class: "item"
                          }, [
                            _createElementVNode("div", _hoisted_24, _toDisplayString(restaurant.name), 1),
                            _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$filters.formattedNumber(restaurant.price)), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ], 64))
                  }), 256))
                : _createCommentVNode("", true),
              (_ctx.delivery.main?.price > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _hoisted_27,
                    _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.delivery.main.price)), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.order.totalPrice > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$filters.formattedNumber(_ctx.order.totalPrice)), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("div", _hoisted_32, [
          _createVNode(_component_MoSpinner)
        ])),
    (_ctx.paymentTypeStore.isOpenSBPModal)
      ? (_openBlock(), _createBlock(_component_ModalDialog, { key: 2 }, {
          default: _withCtx(() => [
            _createVNode(_component_SBPPanel, {
              "total-price": _ctx.payment.price,
              "qr-code-img": _ctx.payment.sbpQrImg,
              "allow-send-at": new Date(_ctx.payment.expireAt),
              "error-text": _ctx.paymentErrorText,
              onTimeOver: _cache[1] || (_cache[1] = () => _ctx.setPaymentError(_ctx.PAYMENT_ERRORS.timeOut)),
              onCheckPayment: _ctx.checkPayment,
              onClose: _ctx.paymentTypeStore.closeSbpModal,
              onRetry: _ctx.process,
              onProcess: _ctx.processSbp
            }, null, 8, ["total-price", "qr-code-img", "allow-send-at", "error-text", "onCheckPayment", "onClose", "onRetry", "onProcess"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}